import styled from "styled-components";
import { Swiper } from 'swiper/react';



export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow-x: hidden;
    padding: 16px 15px 32px;
    gap: 20px;
`
export const Title = styled.h1`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 600;
    font-size: 1.3rem;
    line-height: 1.334;
    letter-spacing: 0em;
    margin: 0;
    align-self: flex-start;
    padding-left: 5%;

    @media (max-width: 750px) {
        padding-left: 0;
    }
`;

export const FullList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
    gap: 20px;
    width: 100%;

    @media (max-width: 900px) {
        grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const FullListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    align-self: flex-start;
    padding-left: 5%;

    @media (max-width: 900px){
        width: 100%;
        align-self: center;
        padding-left: 0;
    }
`

export const StyledSwiper = styled(Swiper)`
    width: 100%;
    padding: 1.5rem;
    position: relative;
    margin-top: -1rem;
    .swiper-slide {
        display: flex;
        justify-content: center;
        transition: transform 0.3s ease;
    }

    .swiper-slide-active {
        transform: scale(1.075);
        z-index: 10;
        margin-left: 10px;
        margin-right: 25px !important;
    }

    @media (max-width: 768px) {
        padding: 1rem 0.5rem;

        .swiper-slide-active {
            transform: scale(1.05);
            margin-left: 5px;
            margin-right: 15px !important;
        }
    }
`;

export const SwiperWrapper = styled.div`
    display: flex;
    width: 90%;
    flex-direction: column; 
    
    @media (max-width: 750px){
        width: 100%;
    }
`;

export const SwiperFadeWrapper = styled.div`
    position: relative;
    width: 100%;

    &::before,
    &::after {
        content: "";
        position: absolute;
        top: 0;
        height: 100%;
        width: 60px;
        pointer-events: none;
        z-index: 2;
        @media (max-width: 600px){
          width: 10px;
        }
    }

    &::before {
        left: 0;
        background: linear-gradient(to right, white 0%, transparent);
    }

    &::after {
        right: 0;
        background: linear-gradient(to left, white 0%, transparent);
    }


`;

export const NavButtonsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: -10px;
    z-index: 5;
`;

export const NavButton = styled.button`
    position: absolute;
    top: 45%;
    z-index: 10;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 2rem;
    opacity: 0.5;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 1;
    }

    &.prev {
      left: -60px;
    }

    &.next {
      right: -60px;
    }

    @media (max-width: 750px) {
      &.prev {
        left: -15px;
      }

      &.next {
        right: -15px;
      }
    }
`;

export const SwiperNavContainer = styled.div`
    position: relative;
    width: 100%;
`;